// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer  viewBox="0 0 38 29"  {...rest} unit={unit}>
		<g id="Social-Icon" transform="translate(8.000000, 8.000000)">
			<path d="M15.1041671,6.25 C16.1067764,6.25 16.9650577,6.60698428
			 17.679037,7.32096354 C18.3930163,8.03494281 18.7500006,8.89322415
			  18.7500006,9.89583333 L18.7500006,11.3541667 C18.7500006,
			  12.3567758 18.3930163,13.2150572 17.679037,13.9290365 C16.9650577,
			  14.6430157 16.1067764,15 15.1041671,15 L10.0000003,15 C8.45051335,
			  15 7.34158343,14.2708406 6.67317729,12.8125 C6.46050261,12.2960044
			  6.35416687,11.8098981 6.35416687,11.3541667 L6.35416687,9.89583333
			  L8.54166694,9.89583333 L8.54166694,11.3541667 C8.54166694,11.779516
			  8.67838432,12.1289049 8.9518232,12.4023438 C9.22526207,12.6757826
			  9.57465095,12.8125 10.0000003,12.8125 L15.1041671,12.8125 C15.5295165,
			  12.8125 15.8789054,12.6757826 16.1523443,12.4023438 C16.4257831,
			  12.1289049 16.5625005,11.779516 16.5625005,11.3541667 L16.5625005,9.89583333
			  C16.5625005,9.47048398 16.4257831,9.12109512 16.1523443,8.84765625 C15.8789054,
			  8.57421738 15.5295165,8.4375 15.1041671,8.4375 L14.3750005,8.4375 C14.2838542,
			  8.01215065 14.1167551,7.61718932 13.8736984,7.25260417 C13.6306416,6.88801901
			  13.4027793,6.62977507 13.1901046,6.47786458 L12.9166671,6.25 L15.1041671,6.25
			  Z M13.3723962,8.4375 C13.5546888,8.89323145 13.6458337,9.3793377 13.6458337,
			  9.89583333 L13.6458337,11.3541667 L11.4583337,11.3541667 L11.4583337,9.89583333
			  C11.4583337,9.47048398 11.3216163,9.12109512 11.0481774,8.84765625 C10.7747385,
			  8.57421738 10.4253496,8.4375 10.0000003,8.4375 L4.89583345,8.4375 C4.47048409,
			  8.4375 4.12109521,8.57421738 3.84765633,8.84765625 C3.57421746,9.12109512
			  3.43750007,9.47048398 3.43750007,9.89583333 L3.43750007,11.3541667
			  C3.43750007,11.779516 3.57421746,12.1289049 3.84765633,12.4023438
			   C4.12109521,12.6757826 4.47048409,12.8125 4.89583345,12.8125 L5.62500014,
			   12.8125 C5.71614643,13.2378493 5.88324546,13.6328107 6.12630224,13.9973958
			   C6.36935902,14.361981 6.59722133,14.6202249 6.80989601,14.7721354 L7.08333352,
			   15 L4.89583345,15 C3.89322424,15 3.03494286,14.6430157 2.32096358,13.9290365
			   C1.60698429,13.2150572 1.25,12.3567758 1.25,11.3541667 L1.25,9.89583333
			   C1.25,8.89322415 1.60698429,8.03494281 2.32096358,7.32096354 C3.03494286,
			   6.60698428 3.89322424,6.25 4.89583345,6.25 L10.0000003,6.25 C10.7291706,
			   6.25 11.4051621,6.45507607 12.0279951,6.86523438 C12.6508281,7.27539268
			   13.0989573,7.79947598 13.3723962,8.4375 Z" id="icon">
			</path>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/SocialIcon.js